.root {
  position: relative;
  display: flex;
  max-width: var(--site-content-max-width);
  padding: 1rem;
  color: var(--card-color);
  background-color: var(--episode-card-background);
  border: 1px solid var(--episode-card-border-color);
  border-radius: 0.5rem;
  transition:
    border-color 1s,
    box-shadow 1s;
}

.playing {
  border: 1px solid var(--secondary);
  box-shadow: 0 0 0 2px var(--secondary);
}

.highlighted {
  border: 1px solid var(--secondary);
  box-shadow:
    0 0 0 2px var(--secondary),
    var(--shadow-large) rgba(158, 158, 158, 0.5);

  &.highreachmention {
    box-shadow:
      0 0 0 2px var(--sentiment-warning),
      var(--shadow-large) rgba(158, 158, 158, 0.5);
  }
}

.highreachmention {
  border-color: rgba(255, 212, 25, 1);
  box-shadow: 0 0 0 2px var(--sentiment-warning);
}
